import Cards from "../../cards/Cards";
import PerformaceVendas from "../../cards/PerformaceVendas";
import ValorCard from "../../cards/ValorCard";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import TabelaExtrato from "../tabelaExtrato/TabelaExtrato";
import "./Historico.css";
import React, { useEffect, useMemo, useState } from "react";
import Api from "../../Services/Api";
import ExtratoFilters from "../tabelaExtrato/ExtratoFilter";

const Historico = () => {
  const [menuClose, setMenuClose] = useState(false);
  const toggleMenu = () => setMenuClose((prev) => !prev);

  const [extratoDados, setExtratoDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const LIMIT = 20;
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const [filters, setFilters] = useState({
    type: "ALL",
    status: "ALL",
    order: "",
    start: "",
    end: "",
  });

  const params = useMemo(() => {
    const p = {
      type: filters.type,
      status: filters.status,
      order: filters.order?.trim(),
      start: filters.start,
      end: filters.end,
      limit: LIMIT,
      offset,
    };

    Object.keys(p).forEach((k) => {
      if (!p[k] || p[k] === "ALL") delete p[k];
    });

    return p;
  }, [filters, offset]);

  const fetchData = async ({ reset = false } = {}) => {
    try {
      setLoading(true);

      const res = await Api.get("/ledger-entries/me/history", { params });
      const payload = res.data?.data ?? res.data ?? [];
      const list = Array.isArray(payload)
        ? payload.filter((item) => String(item?.status || "").trim().toUpperCase() !== "PENDING")
        : [];

      const pagination = res.data?.pagination;
      const more =
        typeof pagination?.hasMore === "boolean"
          ? pagination.hasMore
          : list.length === LIMIT;

      setHasMore(more);

      if (reset) setExtratoDados(list);
      else setExtratoDados((prev) => [...prev, ...list]);
    } catch (err) {
      console.error("Erro ao carregar histórico:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setOffset(0);
    fetchData({ reset: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApplyFilters = () => {
    setOffset(0);
    fetchData({ reset: true });
  };

  const handleClearFilters = () => {
    setFilters({
      type: "ALL",
      status: "ALL",
      order: "",
      start: "",
      end: "",
    });
    setOffset(0);
    fetchData({ reset: true });
  };

  const handleLoadMore = () => {
    if (loading) return;
    setOffset((prev) => prev + LIMIT);
  };

  useEffect(() => {
    if (offset === 0) return;
    fetchData({ reset: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} historicoActive="active" />

      <main className="main-content">
        <Topbar page="Histórico" onToggleMenu={toggleMenu} />

        <Cards>
          <ValorCard />
          <PerformaceVendas />
        </Cards>

        <ExtratoFilters
          filters={filters}
          loading={loading}
          onChange={(partial) => setFilters((prev) => ({ ...prev, ...partial }))}
          onApply={handleApplyFilters}
          onClear={handleClearFilters}
        />

        <TabelaExtrato itensLista={extratoDados} loading={loading}>
          <div>Histórico completo (aguardando confirmação e confirmados).</div>
        </TabelaExtrato>

        <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
          {hasMore && (
            <button className="btn-primary" onClick={handleLoadMore} disabled={loading}>
              {loading ? "Carregando..." : "Carregar mais"}
            </button>
          )}
        </div>
      </main>
    </div>
  );
};

export default Historico;
